<template>
	<div>
		<!--<div class="vh-100 bg-white p-d-72">-->
		<div class="vh-100 bg-white">
			<SOTitleBar
				:page-title="'Data Tambahan'"
				:type="'back'"
				:show-search="false"
				@back="back"
			/>

			<div class="content-wrapper main-page showPageDefault flex-100">
				<div class="w-limit flex-1">
					<div class="p-x-20">
						<SOStep :step="2" :total="2"/>

						<div class="f-regular f-16 f-c-black p-d-16">
							Data opsional, Anda bisa melewatinya.
						</div>

						<div class="m-d-20">
							<SOInputTelp
								:title="'Nomor Telpon'"
								:placeholder="'81234567890'"
								:country-code="customer.country_code"
								v-model="customer.telepon"
								@country-code="(val) => customer.country_code = val"
							/>
							<ErrorMessage
								class="error"
								label="Nomor Telepon"
								:validation="$v.customer.telepon"
							/>
							<div class="f-regular f-12 f-c-midgrey m-t-4">
								Digunakan untuk mengirim nota, status order, dan penyebaran promo — semuanya secara
								otomatis.
							</div>
						</div>

						<div class="m-d-20">
							<SOCardCustomerListAlamatAdd
								:alamat="customer.alamat_customer"
								@add="addAlamat"
							/>

							<div class="f-regular f-12 f-c-midgrey m-t-4">
								Digunakan jika ada pengantaran / penjemputan barang di lokasi konsumen.
							</div>
						</div>
					</div>

					<div class="d-flex justify-content-center p-y-20 border-top"
					     @click="showMoreDetail">
						<div class="f-semi f-16 f-c-blue m-r-4">
							Data lainnya
						</div>
						<img src="@/assets/icons/chevron-rotate-down.svg"
						     id="chev-more-detail"
						     alt="">
					</div>

					<div class="p-x-20 w-limit border-bottom">
						<div id="more-detail" v-show="false">
							<div class="m-d-20">
								<SOInputRegular
									:title="'Instansi'"
									:placeholder="'Instansi'"
									:validation="'alphanumeric'"
									v-model="customer.instansi"
								/>
								<div class="f-regular f-12 f-c-midgrey m-t-4">
									Jika konsumen mewakili suatu instansi
								</div>
								<ErrorMessage
									class="error"
									label="Instansi"
									:validation="$v.customer.instansi"
								/>
							</div>

							<div class="m-d-20">
								<SOInputDate
									:title="'Tanggal lahir'"
									:placeholder="'Tanggal lahir'"
									:value="customer.tanggal_lahir"
									:id="'tanggal-lahir'"
									:max-date="$moment().format('YYYY-MM-DD')"
									@get-date="(val) => { customer.tanggal_lahir = val }"
								/>
								<div class="f-regular f-12 f-c-midgrey m-t-4">
									Target promo: saat konsumen berulang tahun
								</div>
							</div>

							<div class="m-d-20">
								<SOInputSelect
									:title="'Agama'"
									:placeholder="'Agama'"
									:options="optionAgama"
									:selected="customer.agama"
									@option-selected="(val) => { customer.agama = parseInt(val) }"
								/>
								<div class="f-regular f-12 f-c-midgrey m-t-4">
									Target promo: perayaan hari besar agama
								</div>
							</div>

							<div class="m-d-20">
								<SOInputRegular
									:title="'Email'"
									:placeholder="'Email'"
									:validation="'email'"
									v-model="customer.email"
								/>
								<ErrorMessage
									class="error"
									label="Email"
									:validation="$v.customer.email"
								/>
								<div class="f-regular f-12 f-c-midgrey m-t-4">
									Target promo: melalui email
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="p-x-20 w-limit">
					<button class="btn btn-login btn-long"
					        @click="createCustomer"
					        :disabled="pageSetting.disbaleBtn.create">
						Simpan
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOStep from "@/so-components/global/ui/SOStep";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputRadioBig from "@/so-components/global/input/SOInputRadioBig";
import SOInputTelp from "@/so-components/global/input/SOInputTelp";
import SOInputDate from "@/so-components/global/input/SOInputDate";
import SOCardCustomerListAlamatAdd from "@/so-components/modules/customer/SOCardCustomerListAlamatAdd";

import {mapGetters} from "vuex";
import {minLength, maxLength, required, email} from "vuelidate/lib/validators";
import ErrorMessage from "@/component-items/ErrorMessage";

export default {
	name: "CustomerCreateStep2",
	components: {
		SOTitleBar,
		SOStep,
		SOInputSelect,
		SOInputRegular,
		SOInputRadioBig,
		SOInputTelp,
		SOInputDate,
		SOCardCustomerListAlamatAdd,
		ErrorMessage,
	},
	computed: {
		...mapGetters("customerModule", {
			customer: "getDataCreateCustomer",
		}),
		...mapGetters("metaModule", {
			optionAgama: "getAgama",
		}),
	},
	validations: {
		customer: {
			nama: {
				required,
				minLength: minLength(2),
			},
			idoutlet: {
				required,
			},
			jenis_kelamin: {
				required,
			},
			sapaan: {
				required,
			},
			instansi: {
				minLength: minLength(2),
			},
			telepon: {
				minLength: minLength(6),
				maxLength: maxLength(12),
			},
			email: {
				email
			},
		}
	},
	mounted() {
		this.step1Validation()
		this.getAgama()
		this.smartTrackingView("add_konsumen_step_2");

	},
	data() {
		return {
			pageSetting: {
				disbaleBtn: {
					create: false
				}
			}
		}
	},
	methods: {
		back() {
      this.$router.back()
			// this.$router.push("/konsumen/create/1")
		},
		showMoreDetail() {
			$("#more-detail").slideToggle();
			let deg180 = {"transform": "rotate(180deg)"};
			let deg0 = {"transform": "rotate(0deg)"};
			this.rotate ? $('#chev-more-detail').css(deg0) : $('#chev-more-detail').css(deg180);
			this.rotate = !this.rotate;
		},
		addAlamat() {
			this.$router.push("/konsumen/create/alamat")
		},
		async getAgama() {
			const res = await this.$store.dispatch("metaModule/fetchAgama")
			if (!res.success) {
				this.$toast.error(res.err)
			}
		},
		step1ErrorValidation() {
			this.$v.customer.nama.$touch()
			this.$v.customer.idoutlet.$touch()
			this.$v.customer.jenis_kelamin.$touch()
			this.$v.customer.sapaan.$touch()
			return this.$v.customer.nama.$invalid ||
				this.$v.customer.idoutlet.$invalid ||
				this.$v.customer.jenis_kelamin.$invalid ||
				this.$v.customer.sapaan.$invalid
		},
		step1Validation() {
			if (this.step1ErrorValidation()) {
				this.$router.push("/konsumen/create/1")
			}
		},
		errorValidation() {
			this.$v.customer.telepon.$touch()
			this.$v.customer.instansi.$touch()
			this.$v.customer.email.$touch()
			let validateTelepon = (this.customer.telepon !== '') ? this.$v.customer.telepon.$invalid : false
			let validateInstansi = this.$v.customer.instansi.$invalid
			let validateEmail = (this.customer.email !== "") ? this.$v.customer.email.$invalid : false
			return validateTelepon || validateInstansi || validateEmail
		},
		validate() {
			this.pageSetting.disbaleBtn.create = this.errorValidation()
		},
		async createCustomer() {
			if (this.errorValidation()) {
				this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				return
			}
			let customerCreateData = this.customer
			customerCreateData.telepon = (customerCreateData.telepon !== "") ? customerCreateData.telepon : ""
			await this.$store.commit("customerModule/setDataCreateCustomer", customerCreateData)

			const res = await this.$store.dispatch("customerModule/createCustomer")
			if (res.success) {
				this.$toast.success(res.msg)
				this.$store.commit("customerModule/resetDataCreateCustomer")
				await this.$router.push("/konsumen/detail/" + res.data.idcustomer)
			} else {
				this.$toast.error(res.err)
			}
			this.smartTrackingClick("simpan_konsumen");

		}
	}
}
</script>